@if(shouldHaveVinsights() && hasVinsights) {
<div class="flex-container">
    <button mat-stroked-button color="primary" class="count-button" (click)="openVinSights()">
        <mat-icon>stylus_note</mat-icon>
        {{ (count > 1 ? 'vinsights.reggiesNotes' : 'vinsights.reggiesNote') | transloco: { count } }}
    </button>
</div>
}